module.exports = __webpack_public_path__ + "static/media/grand_mum_friend_eye_blink_01.8f3a1852.gif";